export function userVariantMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      userVariantId: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}


export function userVariantMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId, userVariantId: json.result.objectId}
  };
}

export function fixCreateUserVariantId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function fixUpdateUserVariantId(json) {
  return {
    data: {...json.result, id: json.result.objectId},
  };
}

export function fixGetManyUserVariants(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      userVariantId: resource.objectId,
    })),
  };
}